import type { IBuilderState } from '../../../../context/messageManager';

export const MESSAGE_MANAGER_BUILDER_STORAGE_KEY = 'messageManagerBuilderState';

function getBuilderStorageKey(id?: string) {
  return `${MESSAGE_MANAGER_BUILDER_STORAGE_KEY}:${id || 'new'}`;
}

function reviveDates(state: IBuilderState): IBuilderState {
  return {
    ...state,
    step2: {
      ...state.step2,
      statement: {
        ...state.step2.statement,
        mode: undefined,
      },
      endOfStatement: {
        ...state.step2.endOfStatement,
        selected: undefined,
      },
    },
    step4: {
      startDate: new Date(state.step4.startDate),
      endDate: new Date(state.step4.endDate),
    },
  };
}

function toPersistedState(state: IBuilderState): IBuilderState {
  return {
    ...state,
    step2: {
      ...state.step2,
      statement: {
        ...state.step2.statement,
        mode: undefined,
      },
      endOfStatement: {
        ...state.step2.endOfStatement,
        selected: undefined,
      },
    },
  };
}

function isBuilderState(value: unknown): value is IBuilderState {
  return Boolean(value && typeof value === 'object' && 'step1' in value && 'step2' in value && 'step4' in value);
}

export function loadBuilderSnapshot(id?: string): IBuilderState | undefined {
  try {
    const stored = localStorage.getItem(getBuilderStorageKey(id));

    if (!stored) return undefined;

    const parsed = JSON.parse(stored) as IBuilderState | { state?: IBuilderState };
    const state = isBuilderState(parsed) ? parsed : parsed.state;

    if (!isBuilderState(state)) return undefined;

    return reviveDates(state);
  } catch {
    return undefined;
  }
}

export function saveBuilderSnapshot(id: string | undefined, state: IBuilderState) {
  localStorage.setItem(getBuilderStorageKey(id), JSON.stringify(toPersistedState(state)));
}
